module.exports = __webpack_public_path__ + "img/gxx-icon.a59e48a1.png";